import React, { useState, useEffect } from 'react';
import { TextField, Button, Grid, Container, Typography, Box, Snackbar, Alert, CircularProgress } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import axios from 'axios'; // 🟢 Added
import { useLocation } from 'react-router-dom'; // 🟢 Added
import './Claimintimation.css';

function ClaimIntimation() {
  const [formData, setFormData] = useState({
    patientName: '',
    employeeName: '',
    corporateName: '',
    hospitalName: '',
    dateOfAdmission: null,
    dateOfDischarge: null,
    expectedClaimAmount: '',
    employeeCode: '',
    memberId: '',
    policyNo: '',
    contactNo: '',
    emailId: '',
    claimType: '',
  });

  // const [pdfFile, setPdfFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [loading, setLoading] = useState(false);

  const location = useLocation(); // 🟢 Added

  // ✅ Step 1: Restore cached data if available
  useEffect(() => {
    const cachedData = JSON.parse(sessionStorage.getItem('claimIntimationData'));
    if (cachedData) {
      setFormData(cachedData);
    }
  }, []);

  // ✅ Step 2: Cache the data while typing
  useEffect(() => {
    sessionStorage.setItem('claimIntimationData', JSON.stringify(formData));
  }, [formData]);

  // ✅ Step 3: Fetch Corporate Name (accountName) using accountId
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const accountId = query.get('accountId') || sessionStorage.getItem('selectedAccount');

    if (!accountId) return;

    const fetchAccountData = async () => {
      try {
        const res = await axios.get(`https://api.cri.co.in/api/accounts/${accountId}`);
        console.log('✅ Account Data:', res.data);

        // Store account info for future use
        sessionStorage.setItem('selectedAccount', accountId);
        if (res.data.hrNumber) sessionStorage.setItem('mobileNumber', res.data.hrNumber);

        // 🟢 Prefill corporateName with accountName
        if (res.data.accountName) {
          setFormData(prev => ({
            ...prev,
            corporateName: res.data.accountName,
          }));
        }
      } catch (err) {
        console.error('❌ Error fetching account data:', err);
      }
    };

    fetchAccountData();
  }, [location.search]);

  // ✅ Step 4: Auto-fetch “Self” details from your existing live-data API
  useEffect(() => {
    const accountId = sessionStorage.getItem('selectedAccount');
    const role = (sessionStorage.getItem('role') || '').toLowerCase();
  const mobileNumber =
    role === 'hr'
      ? sessionStorage.getItem('mobileNumber')    // 🔹 HR → use HR mobile number
      : sessionStorage.getItem('employeeNumber'); // assuming stored here

    if (!accountId || !mobileNumber) {
      console.warn("❌ Missing accountId or mobileNumber in sessionStorage");
      return;
    }

    const fetchSelfDetails = async () => {
      try {
        const res = await fetch(`https://api.cri.co.in/api/account/${accountId}/live-data-by-mobile/${mobileNumber}`);
        const data = await res.json();

        if (!res.ok) {
          console.error('Error fetching live data:', data.error || data);
          return;
        }

        // ✅ Find only the record where benef_relation is "Self" or "Employee"
        const selfRow = data.find(item =>
          item.benef_relation?.toLowerCase() === 'self' ||
          item.benef_relation?.toLowerCase() === 'employee' ||
          item.benef_relation?.toLowerCase() === 'emp'
        );

        if (!selfRow) {
          console.warn("⚠️ No 'Self' record found for this mobile number");
          return;
        }

        console.log("✅ Self record fetched:", selfRow);

        // ✅ Prefill key fields
        setFormData(prev => ({
          ...prev,
          employeeName: selfRow.pribenef_name || '',
          employeeCode: selfRow.pribenef_employee_code || '',
          memberId: selfRow['Card No'] || '',
          policyNo: selfRow.policy_number || selfRow.polno || '',
          contactNo: selfRow['Mobile No'] || mobileNumber || '',
          emailId: selfRow.benef_email || '',
        }));
      } catch (error) {
        console.error("❌ Error fetching Self details:", error);
      }
    };

    fetchSelfDetails();
  }, []); // run once on mount

  // === Handlers ===
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
  const selectedFiles = Array.from(e.target.files || []);

  setFiles((prev) => {
    // 🔹 avoid duplicates based on name+size+lastModified
    const existingKeys = new Set(
      prev.map(f => `${f.name}-${f.size}-${f.lastModified}`)
    );
    const newOnes = selectedFiles.filter(
      f => !existingKeys.has(`${f.name}-${f.size}-${f.lastModified}`)
    );
    return [...prev, ...newOnes];
  });

  // 🔹 allow selecting the same file again if needed
  e.target.value = "";
};


  const handleDateChange = (name, newValue) => {
    setFormData({
      ...formData,
      [name]: newValue,
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const data = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (key.toLowerCase().includes('date')) { // 🔹 safer date check
        data.append(key, value ? value.format('DD/MM/YYYY') : '');
      } else {
        data.append(key, value);
      }
    });

    // 🔹 multiple files
    if (files && files.length > 0) {
  files.forEach((file) => {
    data.append("pdfFile", file);         // ✅ matches multer.array('pdfFile', ...)
  });
}

    const response = await fetch('https://api.cri.co.in/api/send-email', {
      method: 'POST',
      body: data,
    });

    if (response.ok) {
      setOpenSnackbar(true);
      setFormData({
        patientName: '',
        employeeName: '',
        corporateName: '',
        hospitalName: '',
        dateOfAdmission: null,
        dateOfDischarge: null,
        expectedClaimAmount: '',
        employeeCode: '',
        memberId: '',
        policyNo: '',
        contactNo: '',
        emailId: '',
        claimType: '',
      });
      sessionStorage.removeItem('claimIntimationData');
      setFiles([]); // 🔹 clear all files
    } else {
      const errorText = await response.text();
      alert("Server error: " + errorText);
    }
  } catch (error) {
    alert("Failed to send email. Please try again later.");
    console.error(error);
  } finally {
    setLoading(false);
  }
};

  const handleCloseSnackbar = () => setOpenSnackbar(false);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Container maxWidth="sm">
        <Box
          sx={{
            boxShadow: 4,
            p: 4,
            mt: 4,
            borderRadius: 3,
            backgroundColor: '#ffffff',
            border: '1px solid #e0e0e0',
            transition: '0.3s',
            '&:hover': { boxShadow: 6 },
          }}
        >
          <Typography variant="h4" gutterBottom align="center" sx={{ fontWeight: 'bold', color: '#0d47a1' }}>
            Claim Intimation Form
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>

<Grid item xs={12} sm={6}>
  <TextField
    select
    label="Claim Type (IPD / OPD)"
    name="claimType"
    value={formData.claimType}
    onChange={handleChange}
    fullWidth
    required
    SelectProps={{
      native: true,
    }}
    sx={{
      backgroundColor: '#fff',
      borderRadius: 1,
      border: '1px solid #1976d2',
    }}
  >
    <option value=""></option>
    <option value="IPD">IPD</option>
    <option value="OPD">OPD</option>
  </TextField>
</Grid>


              {Object.keys(formData)
  .filter(key => key !== 'claimType') // 🟢 exclude claimType from auto-loop
  .map((key, index) => (
    <Grid item xs={12} sm={6} key={index}>
      {key.includes('date') ? (
        <DatePicker
          label={key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
          value={formData[key]}
          onChange={(newValue) => handleDateChange(key, newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              required
              sx={{
                backgroundColor: '#fff',
                borderRadius: 1,
                border: '1px solid #1976d2',
              }}
            />
          )}
        />
      ) : (
        <TextField
          label={key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}
          name={key}
          fullWidth
          required
          value={formData[key]}
          onChange={handleChange}
          InputProps={{
            readOnly: ['employeeName', 'corporateName', 'employeeCode', 'contactNo', 'emailId'].includes(key),
          }}
          sx={{
            backgroundColor: ['employeeName', 'corporateName', 'employeeCode', 'contactNo', 'emailId'].includes(key)
              ? '#f9f9f9'
              : '#fff',
            borderRadius: 1,
            border: '1px solid #1976d2',
          }}
        />
      )}
    </Grid>
))}


              {/* PDF Upload */}
              <Grid item xs={12}>
                <Button
  variant="contained"
  component="label"
  fullWidth
  sx={{
    backgroundColor: '#0d47a1',
    '&:hover': { backgroundColor: '#0b3c8c' },
    padding: '12px',
    borderRadius: 2,
    fontWeight: 'bold',
    boxShadow: '0 3px 5px rgba(0, 0, 0, 0.3)',
  }}
>
  Upload File(s)  {/* 🔹 label updated */}
  <input
    type="file"
    accept="application/pdf"   // keep only PDFs, or remove for any file
    hidden
    multiple                   // 🔹 allow selecting multiple
    onChange={handleFileChange}
  />
</Button>

{/* 🔹 Show all selected files */}
{files.length > 0 && (
  <Box sx={{ mt: 2 }}>
    <Typography variant="subtitle2" align="center">
      {files.length} file(s) selected:
    </Typography>
    {files.map((f, i) => (
      <Typography
        key={`${f.name}-${f.size}-${i}`}
        variant="body2"
        align="center"
      >
        • {f.name}
      </Typography>
    ))}
  </Box>
)}

                
              </Grid>

              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={loading}
                  sx={{
                    backgroundColor: '#0d47a1',
                    '&:hover': { backgroundColor: '#0b3c8c' },
                    padding: '12px',
                    borderRadius: 2,
                    fontWeight: 'bold',
                    boxShadow: '0 3px 5px rgba(0, 0, 0, 0.3)',
                    position: 'relative',
                  }}
                >
                  {loading ? (
                    <>
                      <CircularProgress
                        size={24}
                        sx={{
                          position: 'absolute',
                          left: '50%',
                          top: '50%',
                          marginLeft: '-12px',
                          marginTop: '-12px',
                        }}
                      />
                      <span style={{ visibility: 'hidden' }}>Submitting...</span>
                    </>
                  ) : (
                    'Submit'
                  )}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>

        <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
            Submitted successfully!
          </Alert>
        </Snackbar>
      </Container>
    </LocalizationProvider>
  );
}

export default ClaimIntimation;
